"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactCollapse = require("react-collapse");

var _chevronDown = _interopRequireDefault(require("@spothero/icons/chevron-down"));

var _chevronUp = _interopRequireDefault(require("@spothero/icons/chevron-up"));

var _Button = _interopRequireDefault(require("../Button/Button"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var Panel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Panel, _Component);

  var _super = _createSuper(Panel);

  function Panel() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, Panel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isOpen: _this.props.isOpen || false,
      prevIsOpen: false,
      heightReady: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onMeasure", function () {
      _this.setState({
        heightReady: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onToggle", function (evt) {
      evt.preventDefault();

      _this.setState(function (prevState, props) {
        var isOpen = prevState.isOpen;
        return {
          isOpen: !isOpen,
          prevIsOpen: isOpen
        };
      });
    });
    return _this;
  }

  (0, _createClass2.default)(Panel, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
          onOpen = _this$props.onOpen,
          onClose = _this$props.onClose;
      var isOpen = this.state.isOpen;
      var prevIsOpen = prevState.isOpen;

      if (onOpen && isOpen && !prevIsOpen) {
        onOpen();
      }

      if (onClose && !isOpen && prevIsOpen) {
        onClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          title = _this$props2.title,
          children = _this$props2.children,
          showTitleToggle = _this$props2.showTitleToggle,
          preview = _this$props2.preview,
          additionalTitleMarkup = _this$props2.additionalTitleMarkup,
          openIcon = _this$props2.openIcon,
          closeIcon = _this$props2.closeIcon;
      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          heightReady = _this$state.heightReady;
      var classes = (0, _classnames.default)('Panel', {
        'Panel-with-preview': preview
      }, {
        'Panel-open': isOpen
      }, className);
      var contentClasses = (0, _classnames.default)('Panel-content', {
        'Panel-content-hidden': !heightReady
      });
      var showPreview = !(0, _isNil.default)(preview) && !isOpen;
      var panelTitle = (0, _isString.default)(title) ? /*#__PURE__*/_react.default.createElement("div", {
        className: "Panel-title-heading"
      }, title) : title;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "Panel-title"
      }, showTitleToggle ? /*#__PURE__*/_react.default.createElement(_Button.default, {
        className: "Panel-toggle",
        onClick: this._onToggle
      }, panelTitle, isOpen ? closeIcon : openIcon) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, panelTitle, additionalTitleMarkup)), /*#__PURE__*/_react.default.createElement(_reactCollapse.Collapse, {
        isOpened: isOpen || showPreview,
        onMeasure: this._onMeasure,
        springConfig: {
          stiffness: 300,
          damping: 25
        }
      }, isOpen && /*#__PURE__*/_react.default.createElement("div", {
        className: contentClasses
      }, children), showPreview && /*#__PURE__*/_react.default.createElement("div", {
        className: "Panel-preview"
      }, preview)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var nextIsOpen = nextProps.isOpen,
          nextShowTitleToggle = nextProps.showTitleToggle;
      var isOpen = prevState.isOpen,
          prevIsOpen = prevState.prevIsOpen;
      var isOpenStateEqualsNextProp = isOpen === nextIsOpen; // when showTitleToggle is true, we don't want Panel controlled externally

      if (!nextShowTitleToggle && isOpen !== prevIsOpen && isOpenStateEqualsNextProp) {
        // toggled internal state change
        return {
          isOpen: isOpen,
          prevIsOpen: prevIsOpen
        };
      } else if (!nextShowTitleToggle && !isOpenStateEqualsNextProp) {
        // state change happening because of props change by external component
        return {
          isOpen: nextIsOpen,
          prevIsOpen: isOpen
        };
      }

      return null;
    }
  }]);
  return Panel;
}(_react.Component);

(0, _defineProperty2.default)(Panel, "defaultProps", {
  openIcon: /*#__PURE__*/_react.default.createElement(_chevronDown.default, {
    className: "Icon-chevron-down"
  }),
  closeIcon: /*#__PURE__*/_react.default.createElement(_chevronUp.default, {
    className: "Icon-chevron-up"
  })
});
var _default = Panel;
exports.default = _default;